import React, { useEffect, useState } from "react";
import { Card } from "../../../components/Cards/Card";
import { useTranslation } from "react-i18next";
import { useClinicalTrialContext } from "../ClinicalTrialContext";
import { useAuthorization, useAuthProtocol } from "../../../components/Authorization/useAuthorization";
import { Add, Next } from "../../../components/Icons/Icons";
import { ModalCreateRegulatoryEvent } from "../../../components/ClinicalTrials/Regulatory/ModalCreateRegulatoryEvent";
import BootstrapTable from "react-bootstrap-table-next";
import { Tooltip } from "../../../components/Utils/Tooltips";
import { NavLink } from "react-router-dom";
import { Spinner } from "../../../components/Utils/Loaders";
import {
  createRegulatoryEvent,
  getRegulatoryEvents,
} from "../../../api/clinicalTrial";
import { dateFormatter } from "../../../components/Utils/Formatter";
import { toast } from "react-toastify";

export const RegulatoryEvents = (props) => {
  const { t } = useTranslation();
  const { startup } = useClinicalTrialContext();
  const [, , isAuthorizedGlobal] = useAuthorization();
  const [isAuthorizedProtocol] = useAuthProtocol(startup?.protocol?.id);
  const canAddPresentation =
    isAuthorizedGlobal(["Startups.Edit"]) || isAuthorizedProtocol(["Startups.Edit"]);
  const [showModal, setShowModal] = useState(false);
  const [items, setItems] = useState();

  const columns = [
    { dataField: "name", text: "Nombre de presentación" },
    {
      dataField: "dateTime",
      text: "Fecha de actualización",
      formatter: function (cell) {
        return <div>{dateFormatter(cell, "DD/MMM/YYYY HH:mm")}</div>;
      },
    },
    { dataField: "patientName", text: "Paciente" },
    { dataField: "status", text: "Estado" },
    {
      dataField: "view",
      text: "",
      isDummyField: true,
      headerClasses: "header-protocol-actions",
      classes: "row-protocol-actions",
      headerStyle: { width: "100px" },
      headerAlign: "center",
      align: "center",
      formatter: (_cell, row, rowIndex) => (
        <div key={rowIndex}>
          <Tooltip tooltip="Ver más" id={`tooltipvisit-${row.id}`}>
            <NavLink
              to={{
                pathname: `/admin/clinicalTrials/regulatory/${row.id}`,
                state: { startup },
              }}
              activeClassName="active"
              className="btn-table-actions"
            >
              <Next />
            </NavLink>
          </Tooltip>
        </div>
      ),
    },
  ];

  var loadData = async () => {
    const result = await getRegulatoryEvents(startup.protocol.id);

    if (result.status === 200) {
      setItems(result.data.data);
    }
  };

  const handleCreateModalClose = (refresh) => {
    setShowModal(false);

    if (refresh) {
      loadData();
    }
  };

  useEffect(() => {
    if (!startup) {
      return;
    }

    loadData();
  }, [startup]);

  return (
    <>
      <Card
        content={
          <>
            <div style={{ marginTop: "20px" }}>
              <button
                type="button"
                className="btn btn-primary"
                disabled={!canAddPresentation}
                onClick={() => {
                  setShowModal(true);
                }}
              >
                <Add />
                {t("regulatorySubmissions.addRegulatoryLabel")}
              </button>
            </div>
            {items && (
              <div style={{ marginTop: "20px" }}>
                <BootstrapTable
                  bordered={false}
                  hover
                  remote
                  keyField="id"
                  data={items}
                  isLoading={false}
                  onTableChange={() => {}}
                  columns={columns}
                  classes="table-spaced table-spaced-small"
                  wrapperClasses="table-responsive"
                  style={{ paddingTop: "20px" }}
                  noDataIndication={() => <>{t("commons.noData")}</>}
                />
              </div>
            )}
            {!items && (
              <div>
                <Spinner />
              </div>
            )}
          </>
        }
      />

      {showModal && (
        <ModalCreateRegulatoryEvent
          show={showModal}
          onClose={handleCreateModalClose}
          onSave={async (payload, setSaving) => {
            try {
              const result = await createRegulatoryEvent(
                startup.protocol.id,
                payload
              );

              if (result.status === 200 || result.status === 201) {
                if (result.data.warnings?.length) {
                  result.data.warnings.forEach((warning) => {
                    toast.warning(t(warning));
                  });
                }

                handleCreateModalClose(true);
              } else {
                toast.error(t("errors.serverError"));
              }
            } finally {
              setSaving(false);
            }
          }}
        />
      )}
    </>
  );
};

export default RegulatoryEvents;
